<template>
  <div class="form-edit-page">
    <div class="page-header row-space">
      <div>
        <h2>Abertura de Processo Administrativo</h2>
        <p class="page-subtitle">
          Registro inicial do processo e enquadramento do fluxo padrão
        </p>
      </div>
    </div>

    <div class="form-card">
      <div class="row row-space">
        <div class="form-item">
          <label>Tipo de Processo</label>
          <select v-model="processo.tipo">
            <option v-for="tipo in tipos" :key="tipo" :value="tipo">
              {{ tipo }}
            </option>
          </select>
        </div>

        <div class="form-item">
          <label>Nº Processo</label>
          <input v-model="processo.numero" />
        </div>
      </div>

      <div class="row row-space">
        <div class="form-item">
          <label>Estabelecimento</label>
          <input v-model="processo.estabelecimento" />
        </div>

        <div class="form-item">
          <label>Fiscal Responsável</label>
          <input v-model="processo.fiscal" />
        </div>
      </div>

      <div class="row row-space">
        <div class="form-item">
          <label>Data de Abertura</label>
          <input type="date" v-model="processo.data" />
        </div>

        <div class="form-item">
          <label>Situação</label>
          <select v-model="processo.situacao">
            <option>ABERTO</option>
            <option>EM ANDAMENTO</option>
            <option>ENCERRADO</option>
          </select>
        </div>
      </div>

      <div class="form-item row-space">
        <label>Descrição Inicial</label>
        <textarea v-model="processo.descricao" rows="4"></textarea>
      </div>
      

      <div class="form-actions row-space">
        <button class="btn-primary" @click="salvar">
          Salvar Processo
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed } from 'vue'
import { FLUXOS_PADRAO, TIPOS_PROCESSO } from './processosFluxo_24'

const processo = reactive({
  tipo: 'AUTO DE INTIMAÇÃO',
  estabelecimento: '',
  numero: '',
  data: '',
  fiscal: '',
  situacao: 'ABERTO',
  descricao: ''
})

const fluxoAtual = computed(() => FLUXOS_PADRAO[processo.tipo] || [])
const tipos = TIPOS_PROCESSO

function salvar() {
  const payload = {
    ...processo,
    faseAtual: 'ABERTURA',
    proximoAndamento: fluxoAtual.value[1] || null,
    movimentacoes: [
      {
        andamento: 'ABERTURA',
        data: processo.data,
        descricao: processo.descricao,
        usuario: processo.fiscal
      }
    ]
  }

  console.log('Processo criado:', payload)
}
</script>